// extracted by mini-css-extract-plugin
export default {"icon-block-root":"IconBlock_icon-block-root__qAM5b","group":"IconBlock_group__IJzWc","block":"IconBlock_block__HlRoO"};